import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { clearParentUnlock } from "@/lib/parentUnlock";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import IntroVideoModal from "@/components/intro/IntroVideoModal";
import TrialGate from "@/components/trial/TrialGate";
import { isReadingApp } from "@/lib/readingApp";

export default function ProtectedRoute({ children, adminOnly = false, kid = false }) {
  const { user, loading } = useAuth();
  useEffect(() => { if (kid) clearParentUnlock(); }, [kid]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <Loader2 className="animate-spin text-blue-600" size={40} />
      </div>
    );
  }
  if (!user) return <Navigate to={isReadingApp() ? "/lecture" : "/login"} replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  if (!adminOnly && !user.is_admin) {
    if (user.access_state === "survey_required") return <Navigate to="/survey" replace />;
    if (user.access_state === "expired") return <Navigate to="/access-ended" replace />;
  }
  if (kid && user.intro_required && !isReadingApp()) return <>{children}<IntroVideoModal mandatory /></>;
  if (kid && !user.is_admin) return <>{children}<TrialGate /></>;
  return children;
}
